<template>
    <a-table :columns="columns" :data-source="data" rowKey="id" :pagination="false">
      <template v-slot:action="{ record }">
         <div style="width:120px;textAlign:center">
             <a-switch :checkedValue="1" :unCheckedValue="0" checked-children="启用" un-checked-children="禁用" v-model:checked="record.status" v-if="record.is_sys!=1" @change="changeSwitch(record.id)"/>
             <div v-else>默认，不能修改</div>
         </div>
      </template>
    </a-table>
</template>

<script>
import {onMounted, reactive, ref, toRefs} from 'vue';
import {memberWish,editMemberWish} from '@/api/member.js'
import { iscode } from "@/utils/app";
import { message } from 'ant-design-vue';
const columns = [{
     title:'文案内容',
     dataIndex: "content"
},{
    title:'操作',
    key: "action",
    width:100,
    align: 'center',
    slots: { customRender: "action" },
}]
export default {
    setup(){
       const state = reactive({
           data:[],
            pagination:{
             total:10,
             current:1,
             pageSize:8
           }
       })

       const methods ={
          async getList(){
            const hide = message.loading("正在加载中...", 0);
            let res = await memberWish().then(res=>res.data);
            setTimeout(hide)
            if(iscode(res)){
               state.data= res.data;
            }else{
                message.error(res.msg)
            }
           },
           async changeSwitch(id){
               const hide = message.loading("正在加载中...", 0);
              let res = await editMemberWish(id).then(res=>res.data);
              setTimeout(hide)
              if(iscode(res)){
                message.getList();
                message.success(res.msg)
              }else{
                  message.error(res.msg)
              }
           }
       }

       onMounted(()=>{
           methods.getList()
       })
       return{
           columns,
           ...toRefs(state),
           ...methods
       }
    }
}
</script>